module.exports = __webpack_public_path__ + "img/news.9d93bad2.webp";